import { Ajaxinate } from "../utils/ajaxinate";
import api from "../services/api";
import { $Q, $Qll } from "../utils/query-selector";
import { stringToHTML } from "../utils/to-html";
import { dataToggle } from "../utils/toggle-dataset";

/**
* Executes pagination with infinite scroll effect
* @param {*} containerCard | Container of each item
* @param {*} containerPaginate | link item selector leading to the following page
* @param {*} method | click | scroll
*/

function readMorePaginate(containerCard, containerPaginate, method = 'click') {
  if($Q(containerCard)) {
    new Ajaxinate({
      container: containerCard,
      pagination: containerPaginate,
      method: method
    });
  }
}

/**
 * This function adds the change event to the blog filter
 */
function eventSelect() {
  const filter = $Q('.main-blog__select');
  if(!filter) return;
  filter.addEventListener('change', sendObjectToApi);
}

export function readCardsTagClick() {
  const cardTags = $Qll('.article-card__type');

  if(!cardTags) return;

  cardTags.forEach(tag => {
    const link = tag.dataset.link;

    tag.onclick = () => {
      dataToggle(tag);
      const select = $Q('.main-blog__select');
      select.value = link;
      sendObjectToApi(null, link);
      window.scrollTo(0,0);
    }
  })
}

export function readCardsClick() {
  const cards = $Qll('.article-card-link');

  if(!cards) return;

  cards.forEach(card => {
    card.onclick = (e) => {
      e.preventDefault();

      const cardTag = $Q('.article-card__type', card);

      if(!cardTag || cardTag.dataset.active === "false") {
        window.location.assign(card.getAttribute('href'));
      }
    }
  })
}

/**
 *
 * @param {Event} e Filter detected event
 * This function sends the corresponding information to the section rendering api
 */
const sendObjectToApi = async (e, link) => {
  let pathnameClean = '';

  if(link) {
    pathnameClean = window.location.pathname.includes("tagged")
    ? window.location.pathname.split("/tagged")[0] + `/tagged/${link}`
    : window.location.pathname + `/tagged/${link}`
  } else {
    let tagged = "";
    if(e.target.value != "*") tagged = `/tagged/${e.target.value}`;
    pathnameClean = window.location.pathname.includes("tagged")
      ? window.location.pathname.split("/tagged")[0] + tagged
      : window.location.pathname + tagged
  }

  const renderingObject = {
    pathname: pathnameClean,
    sectionId: "main-blog",
    node: $Q('.main-blog__rendering')
  };

  const response = await api.shopifySectionByUrl(renderingObject.pathname, renderingObject.sectionId);
  renderResponseSection(response, renderingObject);
  readCardsTagClick();
  readCardsClick();
}

/**
 *
 * @param {HTML Object} response Api section rendering response object
 * @param {Object} renderingObject
 * This function is responsible for replacing the current content with that of the api response
 */
const renderResponseSection = (response, renderingObject) => {
  const resultsMarkup = stringToHTML(response)
    .querySelector('.main-blog__rendering').innerHTML;

  window.history.replaceState(null, "", renderingObject.pathname);
  renderingObject.node.innerHTML =  resultsMarkup;
  readMorePaginate('.main-blog__articles', 'ul.main-blog__articles-list');
}

readMorePaginate('.main-blog__articles', 'ul.main-blog__articles-list');
eventSelect();
readCardsTagClick();
readCardsClick();

if(screen.width < 700 || window.innerWidth < 700){
  const prevNotExist = document.querySelectorAll('.new-paging .prev a').length === 0;
  const nextNotExist = document.querySelectorAll('.new-paging .next a').length === 0;
  if(!prevNotExist) document.querySelector('.new-paging .prev a').innerText = "«";
  if(!nextNotExist) document.querySelector('.new-paging .next a').innerText = "»";
}